<template>
  <div class="video-page" v-if="isOpen">
    <div class="video-box">
      <div class="angl_l_t angl"></div>
      <div class="angl_l_b angl"></div>
      <div class="angl_r_t angl"></div>
      <div class="angl_r_b angl"></div>
      <div class="close_btn" @click="close()"></div>
      <div class="video-content">
        <div class="video-content-left">
          <video-player
            ref="videoPlayerWindow"
            class="window-video-player"
            :options="playerOptions"
            @play="play"
            @pause="pause"
            @ended="onVideoEnded"
          ></video-player>
          <div class="video-btns">
            <img
              @click="prevVideo"
              :src="
                hoverPrevious
                  ? require('../../../assets/images/socializationIcon/block/video/icon_syj_c.png')
                  : require('../../../assets/images/socializationIcon/block/video/icon_syj.png')
              "
              @mouseover="hoverPrevious = true"
              @mouseout="hoverPrevious = false"
            />
            <img
              @click="nextVideo"
              :src="
                hoverNext
                  ? require('../../../assets/images/socializationIcon/block/video/icon_xyj_c.png')
                  : require('../../../assets/images/socializationIcon/block/video/icon_xyj.png')
              "
              @mouseover="hoverNext = true"
              @mouseout="hoverNext = false"
            />
          </div>
        </div>
        <div class="video-content-right">
          <div class="video-title two-ellipsis">
            {{
              (videoList[currentIndex] && videoList[currentIndex].videoTitle) ||
              ""
            }}
          </div>
          <div class="video-detial-title">详情</div>
          <div style="display: flex">
            <div
              class="video-detial"
              :style="
                isShowVideoDetial
                  ? '-webkit-line-clamp: 999;'
                  : '-webkit-line-clamp: 3;'
              "
            >
              <div
                class="video-detial-toggle"
                v-if="
                  videoList[currentIndex].videoDescribe &&
                  videoList[currentIndex].videoDescribe.length >= 63
                "
                @click="isShowVideoDetial = !isShowVideoDetial"
              >
                &nbsp;&nbsp;{{ isShowVideoDetial ? "收起" : "展开" }}
              </div>
              {{ videoList[currentIndex].videoDescribe || "--" }}
            </div>
          </div>
          <div class="video-list-title">视频列表</div>
          <div class="video-list-box">
            <div class="video-list-div" ref="videoListRef2">
              <div
                class="video-item"
                v-for="(item, index) in videoList"
                :key="index"
                :class="{ 'video-active': currentIndex === index }"
                @click="selectedVideo(index)"
              >
                <div class="img-div">
                  <div class="img-div-content">
                    <img :src="item.videoCoverPicturePath || ''" />
                    <div class="img-div-modal"></div>
                    <div class="img-div-player"></div>
                  </div>
                </div>
                <div class="img-video-title">
                  <div class="two-ellipsis">{{ item.videoTitle || "" }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 合作社类型
    videoList: {
      type: Array,
      default() {
        return [];
      },
    },
    currentInd: {
      number: {
        type: Number,
        default() {
          return 0;
        },
      },
    },
  },
  data() {
    return {
      //打开弹窗
      isOpen: false,
      // hover上一个
      hoverPrevious: false,
      // hover下一个
      hoverNext: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        autoplay: true,
        muted: true,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        sources: [
          {
            type: "video/mp4",
            src: "", // 初始为空，将在mounted钩子中设置
          },
        ],
        controlBar: false,
        // controlBar: {
        //   timeDivider: true,
        //   durationDisplay: true,
        //   remainingTimeDisplay: true,
        //   fullscreenToggle: true,
        //   playToggle: true,
        //   progressControl: true,
        //   playbackRateMenuButton: false,
        //   volumePanel: false,
        // },
        volumePanel: {
          inline: false, // 设为false则为垂直
        },
        playToggle: true,
        progressControl: true,
        durationDisplay: true,
        // remainingTimeDisplay: true,
        fullscreenToggle: true,
      },
      //视频相关
      currentIndex: 0,
      scrollDistance: 50,
      // 是否展开详情信息
      isShowVideoDetial: false,
    };
  },
  created() {},
  mounted() {
    // this.open();
  },
  watch: {
    currentIndex: {
      deep: true,
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          this.srcollTable(val);
        });
      },
    },
  },
  methods: {
    // hover上一个
    hoverImage(type) {},
    // hover下一个
    resetImage(type) {},
    // 选中更多视频中的一个
    selectedVideo(index) {
      this.currentIndex = index;
      this.playerOptions.sources[0].src =
        this.videoList[this.currentIndex].videoFilePath;
      this.$refs.videoPlayerWindow.player.play(); // 自动播放
    },
    close() {
      this.$store.dispatch("setShowMark", false);
      this.$emit("playVideo");
      this.isOpen = false;
    },
    open() {
      this.$store.dispatch("setShowMark", true);
      this.isOpen = true;
      if (this.currentIndex == this.currentInd) {
        this.$nextTick(() => {
          this.srcollTable(this.currentInd);
        });
      }
      this.currentIndex = this.currentInd;
      this.playerOptions.sources[0].src =
        this.videoList[this.currentIndex].videoFilePath;
    },
    // 手动执行滚动高度
    srcollTable(val) {
      let container = this.$refs.videoListRef2;
      if (container) {
        let childNodes = container.childNodes;
        if (childNodes.length > 0) {
          for (var i = 0; i < childNodes.length; i++) {
            let child = childNodes[i];
            if (child.nodeType === Node.ELEMENT_NODE) {
              // 确保是元素节点
              this.scrollDistance = childNodes[0].offsetHeight;
              break;
            }
          }
        }
        if (
          this.videoList.length > 4 &&
          this.currentIndex <= this.videoList.length - 4
        ) {
          container.scrollTop = this.scrollDistance * val;
          container.classList.add("scroll-animated");
        } else {
          if (this.videoList.length >= 5) {
            container.scrollTop =
              this.scrollDistance * (this.videoList.length - 4);
          }
          // if(this.videoList.length == 5) {
          //   container.scrollTop = this.scrollDistance * 1;
          // }else if(this.videoList.length == 6) {
          //   container.scrollTop = this.scrollDistance * 2;
          // }else if(this.videoList.length == 7) {
          //   container.scrollTop = this.scrollDistance * 3;
          // }else if(this.videoList.length == 8) {
          //   container.scrollTop = this.scrollDistance * 4;
          // }else if(this.videoList.length == 9) {
          //   container.scrollTop = this.scrollDistance * 5;
          // }else if(this.videoList.length == 10) {
          //   container.scrollTop = this.scrollDistance * 6;
          // }
        }
      }
    },
    onVideoEnded() {
      this.nextVideo();
    },
    // 播放
    play() {
      console.log("play");
    },
    // 暂停
    pause() {
      console.log("pause");
    },
    prevVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayerWindow.player.play(); // 自动播放
      } else {
        this.currentIndex = this.videoList.length - 1;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayerWindow.player.play(); // 自动播放
      }
    },
    nextVideo() {
      if (this.currentIndex < this.videoList.length - 1) {
        console.log("nextVideo.this.currentIndex:::", this.currentIndex);
        this.currentIndex++;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayerWindow.player.play(); // 自动播放
      } else {
        this.currentIndex = 0;
        this.playerOptions.sources[0].src =
          this.videoList[this.currentIndex].videoFilePath;
        this.$refs.videoPlayerWindow.player.play(); // 自动播放
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@assets/css/var.scss";

.video-page {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 800;
}

.video-box {
  width: vw(1648);
  height: vh(762);
  background: rgba(3, 49, 19, 0.8);
  position: relative;
  padding: vh(24) vw(20) vh(20) vw(20);
  .angl {
    position: absolute;
    width: vw(50);
    height: vh(50);
  }
  .angl_l_t {
    top: 0;
    left: 0;
    background: url("../../../assets/images/socializationIcon/block/video/icon_video_lt.png")
      no-repeat;
    background-size: 100% 100%;
  }
  .angl_l_b {
    bottom: 0;
    left: 0;
    background: url("../../../assets/images/socializationIcon/block/video/icon_video_lb.png")
      no-repeat;
    background-size: 100% 100%;
  }
  .angl_r_t {
    top: 0;
    right: 0;
    background: url("../../../assets/images/socializationIcon/block/video/icon_video_rt.png")
      no-repeat;
    background-size: 100% 100%;
  }
  .angl_r_b {
    bottom: 0;
    right: 0;
    background: url("../../../assets/images/socializationIcon/block/video/icon_video_rb.png")
      no-repeat;
    background-size: 100% 100%;
  }
  .close_btn {
    z-index: 3;
    position: absolute;
    width: 16px;
    height: 16px;
    background: url("../../../assets/images/socializationIcon/block/video/icon_video_cloase.png")
      no-repeat;
    background-size: 100% 100%;
    top: -5px;
    right: -5px;
    cursor: pointer;
  }
  .video-content {
    width: 100%;
    height: 100%;
    display: flex;
    .video-content-left {
      position: relative;
      .window-video-player {
        width: vw(1266);
        height: vh(713);
        ::v-deep .video-js {
          height: 100%;
          width: 100%;
          .vjs-slider {
            height: vh(8);
          }
          .vjs-play-progress {
            background-color: rgba(97, 255, 179, 1);
            height: vh(8);
            position: relative;
          }
          .vjs-play-progress:before {
            font-size: 1.2em;
            top: vh(-2);
          }
          .vjs-play-progress:hover:before {
            font-size: 1.2em;
            top: vh(-5);
          }
          .vjs-volume-level {
            background-color: rgba(97, 255, 179, 1);
          }
          .vjs-big-play-button {
            display: none;
          }
          .vjs-paused,
          .vjs-playing {
            width: vw(21);
            height: vh(24);
            position: absolute;
            left: vw(24);
            bottom: vh(16);
          }
          .vjs-play-control {
            .vjs-icon-placeholder:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(21); /* 图片宽度 */
              height: vh(24); /* 图片高度 */
              background-image: url("../../../assets/images/socializationIcon/block/video/icon_bf.png"); /* 图片路径 */
              background-size: contain; /* 或者 contain，根据需求 */
              background-repeat: no-repeat;
              background-position: center; /* 图片位置 */
            }
            .vjs-icon-placeholder:hover:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(21); /* 图片宽度 */
              height: vh(24); /* 图片高度 */
              background-image: url("../../../assets/images/socializationIcon/block/video/icon_bf_c.png"); /* 图片路径 */
              background-size: contain; /* 或者 contain，根据需求 */
              background-repeat: no-repeat;
              background-position: center; /* 图片位置 */
            }
          }
          .vjs-play-control.vjs-playing {
            .vjs-icon-placeholder:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(21); /* 图片宽度 */
              height: vh(24); /* 图片高度 */
              background-image: url("../../../assets/images/socializationIcon/block/video/icon_zt.png"); /* 图片路径 */
              background-size: contain; /* 或者 contain，根据需求 */
              background-repeat: no-repeat;
              background-position: center; /* 图片位置 */
            }
            .vjs-icon-placeholder:hover:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(21); /* 图片宽度 */
              height: vh(24); /* 图片高度 */
              background-image: url("../../../assets/images/socializationIcon/block/video/icon_zt_c.png"); /* 图片路径 */
              background-size: contain; /* 或者 contain，根据需求 */
              background-repeat: no-repeat;
              background-position: center; /* 图片位置 */
            }
          }
          .vjs-button > .vjs-icon-placeholder:before {
            font-size: 2.5em;
            line-height: 1.67;
          }
          .vjs-progress-control {
            width: vw(1180);
            height: vh(8);
            position: absolute;
            left: vw(16);
            bottom: vh(56);
          }
          .vjs-duration {
            display: block;
            position: absolute;
            right: vw(6);
            bottom: vw(76);
            height: vh(8);
            font-size: fontSize(16);
          }
          .vjs-volume-panel {
            position: absolute;
            bottom: vh(16);
            right: vw(72);
            width: vw(28);
            height: vh(30);
            z-index: 22;
            .vjs-volume-control.vjs-volume-vertical {
              // width: vw(52);
              // height: vh(160);
              bottom: vh(90);
              left: vw(-40);
              background: rgba(3, 49, 19, 0.8);
              border-radius: 6px;
              .vjs-slider {
                height: 70%;
              }
            }
            .vjs-control-text {
              display: none;
            }
            .vjs-mute-control {
              cursor: pointer;
              display: flex;
              padding: 0;
              .vjs-icon-placeholder {
                position: relative;
                width: vw(28);
                height: vh(28);
                display: flex;
              }
              .vjs-icon-placeholder:before {
                content: ""; /* 不需要使用 content 属性 */
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: vw(29); /* 图片宽度 */
                height: vh(24); /* 图片高度 */
                background-image: url("../../../assets/images/socializationIcon/block/video/icon_voice.png"); /* 图片路径 */
                background-size: contain; /* 或者 contain，根据需求 */
                background-repeat: no-repeat;
                background-position: center; /* 图片位置 */
              }
              .vjs-icon-placeholder:hover:before {
                content: ""; /* 不需要使用 content 属性 */
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: vw(29); /* 图片宽度 */
                height: vh(24); /* 图片高度 */
                background-image: url("../../../assets/images/socializationIcon/block/video/icon_voice_c.png"); /* 图片路径 */
                background-size: contain; /* 或者 contain，根据需求 */
                background-repeat: no-repeat;
                background-position: center; /* 图片位置 */
              }
            }
            .vjs-mute-control.vjs-vol-0 {
              .vjs-icon-placeholder:before {
                content: ""; /* 不需要使用 content 属性 */
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: vw(29); /* 图片宽度 */
                height: vh(24); /* 图片高度 */
                background-image: url("../../../assets/images/socializationIcon/block/video/icon_jy.png"); /* 图片路径 */
                background-size: contain; /* 或者 contain，根据需求 */
                background-repeat: no-repeat;
                background-position: center; /* 图片位置 */
              }
              .vjs-icon-placeholder:hover:before {
                content: ""; /* 不需要使用 content 属性 */
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: vw(29); /* 图片宽度 */
                height: vh(24); /* 图片高度 */
                background-image: url("../../../assets/images/socializationIcon/block/video/icon_jy_c.png"); /* 图片路径 */
                background-size: contain; /* 或者 contain，根据需求 */
                background-repeat: no-repeat;
                background-position: center; /* 图片位置 */
              }
            }
          }
          .vjs-fullscreen-control {
            position: absolute;
            bottom: vh(20);
            right: vw(24);
            width: vw(24);
            height: vh(24);
          }
          .vjs-fullscreen-control {
            .vjs-icon-placeholder:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(24); /* 图片宽度 */
              height: vh(24); /* 图片高度 */
              background-image: url("../../../assets/images/socializationIcon/block/video/icon_video_qp_s.png"); /* 图片路径 */
              background-size: cover; /* 或者 contain，根据需求 */
              background-position: center; /* 图片位置 */
            }
            .vjs-icon-placeholder:hover:before {
              content: ""; /* 不需要使用 content 属性 */
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: vw(24); /* 图片宽度 */
              height: vh(24); /* 图片高度 */
              background-image: url("../../../assets/images/socializationIcon/block/video/icon_video_qp_c.png"); /* 图片路径 */
              background-size: cover; /* 或者 contain，根据需求 */
              background-position: center; /* 图片位置 */
            }
          }
        }
        ::v-deep .video-js .vjs-tech {
          object-fit: fill;
        }
        ::v-deep .vjs-poster {
          background-size: cover;
        }
      }
      .video-btns {
        position: absolute;
        left: vw(50);
        bottom: vh(16);
        img {
          position: relative;
          width: vw(24);
          height: vh(24);
          margin-left: vw(24);
          cursor: pointer;
          pointer-events: auto !important;
        }
      }
    }
    .video-content-right {
      width: vw(324);
      max-height: vh(706);
      font-size: fontSize(14);
      color: #ffffff;
      margin: vh(16) 0 0 vw(16);
      position: relative;
      overflow: hidden;
      .video-title {
        font-size: fontSize(20);
        line-height: vh(28);
        margin-bottom: vh(20);
      }
      .video-detial-title {
        color: rgba(0, 175, 111, 1);
        margin-bottom: vh(10);
        font-size: fontSize(16);
      }
      .video-list-title {
        color: rgba(0, 175, 111, 1);
        margin: vh(8) 0 vh(6) 0;
        font-size: fontSize(16);
      }
      .video-list-box {
        width: vw(324);
        height: vh(498);
        background: rgba(0, 34, 11, 1);
        overflow: hidden;
        .video-list-div {
          height: vh(456);
          margin: vh(16) 0 vh(16) vw(16);
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          .video-item {
            width: 100%;
            padding-bottom: vh(16);
            display: flex;
            color: #ffffff;
            transition: all 0.5s ease;
            .img-div {
              position: relative;
              height: vh(94);
              .img-div-content {
                position: relative;
                img {
                  width: vw(168);
                  height: vh(94);
                }
                .img-div-modal {
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  background: rgba(0, 0, 0, 0.4);
                }
                .img-div-player {
                  width: vw(40);
                  height: vh(40);
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  margin: auto;
                  background-image: url("../../../assets/images/socializationIcon/block/icon_video_list_bf.png");
                  background-repeat: no-repeat;
                  background-size: 100% 100%;
                }
              }
            }
            .img-video-title {
              // display: flex;
              // align-items: center;
              // justify-content: flex-start;
              flex: 1;
              height: vh(94);
              padding: vh(22) vw(11) vh(20) vw(8);
              div {
                height: vh(52);
                text-align: left;
                font-size: fontSize(14);
                line-height: vh(26);
                overflow: hidden;
              }
            }
          }
          .video-active {
            img {
              border: 2px solid #00b14b;
            }
            .img-video-title {
              color: rgba(27, 255, 129, 1);
              background: #003812;
            }
          }
        }
      }
      .video-detial {
        color: rgba(176, 255, 211, 1);
        line-height: vh(28);
        min-height: vh(80);
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        .video-detial-toggle {
          color: rgba(0, 175, 111, 1);
          float: right;
          clear: both;
          cursor: pointer;
        }
      }
      .video-detial::before {
        content: "";
        float: right;
        width: 0;
        height: 100%;
        margin-bottom: vh(-28);
      }
    }
  }
}

.ellipsis {
  overflow: hidden; /* 确保文本超出容器时会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 显示省略号来表示文本被截断 */
}

.two-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

// ::v-deep.vjs-volume-vertical {
//   .vjs-volume-bar.vjs-slider-vertical {
//     height: vh(123) !important;
//   }
// }

.video-list-div::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.video-list-div::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 2px;
  background-color: rgba(0, 175, 111, 1);
  background-image: -webkit-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.2) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.2) 75%,
    transparent 75%,
    transparent
  );
}
.video-list-div::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #023f30;
  border-radius: 2px;
}

/* 设置动画 */
.scroll-animated {
  animation: scroll-animation 2s infinite;
}

@keyframes scroll-animation {
  0% {
    scroll-top: 0;
  }
  100% {
    scroll-top: 50px; /* 根据需要调整 */
  }
}
</style>
